import React from "react";
import { Segment, Menu, Feed } from "semantic-ui-react";
import firebase from "../../firebase";

class Leaderboard extends React.Component {
  state = {
    users: [],
    usersRef: firebase.database().ref("users"),
  };

  componentDidMount() {
    this.addListeners();
  }

  componentWillUnmount() {
    this.removeListeners();
  }

  addListeners() {
    let loadedUsers = [];
    this.state.usersRef.on("child_added", (snap) => {
      let user = snap.val();
      user["uid"] = snap.key;
      user.contributions =
        user.contributions === undefined || user.contributions === null
          ? 0
          : user.contributions;
      loadedUsers.push(user);
      this.setState({ users: loadedUsers });
    });

    this.state.usersRef.on("child_changed", (snap) => {
      let user = snap.val();
      let updatedArray = [...this.state.users];
      let index = updatedArray.findIndex((u) => u.uid === snap.key);
      updatedArray[index] = user;
      user.uid = snap.key;
      this.setState({ users: updatedArray });
    });
  }

  removeListeners() {
    this.state.usersRef.off();
  }

  usersSortDefinition(user1, user2) {
    let c1 = user1.contributions;
    let c2 = user2.contributions;
    if (c1 > c2) return -1;
    else if (c1 < c2) return 1;
    else return 0;
  }

  displayTopContributors(noOfUsers) {
    if (this.state.users) {
      let users = [...this.state.users];
      let sortedUsers = users.sort(this.usersSortDefinition);
      return sortedUsers.slice(0, noOfUsers).map((user, index) => (
        <Menu.Item>
          <Feed>
            <Feed.Event>
              <Feed.Label image={user.avatar} />
              <Feed.Content style={{ color: "green" }}>
                {user.contributions}
                {" gems!"}
                <Feed.Summary>{user.name} </Feed.Summary>
              </Feed.Content>
            </Feed.Event>
          </Feed>
        </Menu.Item>
      ));
    } else {
      return "Loading...";
    }
  }

  render() {
    return (
      <Segment style={{ overflow: "auto", maxHeight: 240 }}>
        <Menu secondary vertical>
          {this.displayTopContributors(3)}
        </Menu>
      </Segment>
    );
  }
}

export default Leaderboard;



// WEBPACK FOOTER //
// ./src/components/MetaPanel/Leaderboard.js